import { render, staticRenderFns } from "./CustomerCampaignReferral.vue?vue&type=template&id=3abd3c74"
import script from "./CustomerCampaignReferral.vue?vue&type=script&lang=js"
export * from "./CustomerCampaignReferral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports